import React from 'react'
import { Button, Form, InputNumber, Spin, Typography } from 'antd'
import { logisticsSettingsApi } from 'api/logisticsSettings'
import { IUpdateLogisticsSettings } from 'models/logisticsSettings'
import { showMessage } from 'shared/utils/showMessage'
import { showServerError } from 'shared/utils/showServerError'
import { OrderPlacesCard } from './OrderPlacesCard'
import styles from './Logistics.module.scss'

const MIN_DAYS = 1
const MAX_DAYS = 90

export const ActionsLogistics: React.FC = () => {
  const [form] = Form.useForm<IUpdateLogisticsSettings>()
  const [isLoading, setIsLoading] = React.useState(true)
  const [isSaving, setIsSaving] = React.useState(false)

  const getSettings = async () => {
    try {
      setIsLoading(true)
      const response = await logisticsSettingsApi.getSettings()
      form.setFieldsValue({
        courier_delivery_days_from: response.data.courier_delivery_days_from,
        pvz_delivery_days_from: response.data.pvz_delivery_days_from
      })
    } catch (e) {
      showServerError(e)
    } finally {
      setIsLoading(false)
    }
  }

  React.useEffect(() => {
    getSettings()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onSave = async (values: IUpdateLogisticsSettings) => {
    try {
      setIsSaving(true)
      await logisticsSettingsApi.updateSettings(values)
      showMessage('success', 'Сроки доставки сохранены', '')
    } catch (e) {
      showServerError(e)
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <div className={styles.root}>
      <OrderPlacesCard />
      <div className={styles.wrapper}>
        <Typography.Title level={4}>Сроки доставки</Typography.Title>
        <Typography.Text type='secondary' className={styles.description}>
          Покупатель видит эти сроки в карточке товара
        </Typography.Text>
        <Spin spinning={isLoading}>
          <Form form={form} layout='vertical' onFinish={onSave}>
            <Form.Item
              label='Курьером'
              name='courier_delivery_days_from'
              rules={[{ required: true, message: 'Укажите срок доставки' }]}
            >
              <InputNumber
                className={styles.field}
                min={MIN_DAYS}
                max={MAX_DAYS}
                precision={0}
                addonBefore='от'
                addonAfter='дней'
              />
            </Form.Item>
            <Form.Item
              label='Пункты выдачи'
              name='pvz_delivery_days_from'
              rules={[{ required: true, message: 'Укажите срок доставки' }]}
            >
              <InputNumber
                className={styles.field}
                min={MIN_DAYS}
                max={MAX_DAYS}
                precision={0}
                addonBefore='от'
                addonAfter='дней'
              />
            </Form.Item>
            <Button type='primary' htmlType='submit' loading={isSaving}>
              Сохранить
            </Button>
          </Form>
        </Spin>
      </div>
    </div>
  )
}
